import Copy from 'assets/img/icons/copy.svg';
import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import LoadingCustom from 'components/layouts/loading/loading';
import { useOuterClick } from 'providers/OutsideClick';
import ModalWorkerType from '../modal';

interface PropsType {
  t : (key: string) => string
}

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const ButtonCopyID = styled(Button)`
  width: 100%;
  width: 37px;
  height: 24px;
  float: right;
  background-color: #9aff5b;
`;

const CustomTableMod = styled.div`
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};
function Index(props: PropsType) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const { workerTypeList, keyWorkerType } = useSelector((state) => ({
    workerTypeList: state?.wla?.worker_type_list,
    keyWorkerType: state?.loading?.listKey?.companyWorkerType,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
            || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const actionID = (id: string) => (
    <ButtonCopyID
      func={() => {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            toast.success('ID Copied!');
          })
          .catch(() => {
            toast.error('ID Not Copied!');
          });
      }}
    >
      <span>
        <img src={Copy} alt="copy_id" />
      </span>
    </ButtonCopyID>
  );

  const actionEdit = ({ data, i }) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setTypeForm('edit');
        setId(i);
        setDataEdit(data);
      }}
    >
            &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: 'ID',
      sortField: true,
      cell: (row) => actionID(row.worker_type_id),
      headerStyle: {
        padding: '0px',
        justifyContent: 'start',
      },
      style: {
        padding: '0px',
        justifyContent: 'start',
      },
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('wla.status.detail.type'),
      sortField: true,
      selector: (row) => row.worker_type_name,
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      width: '15%',
      cell: (row, i) => actionEdit({ data: row, i }),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalWorkerType
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        dataWorkerType={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="worker_type_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyWorkerType ? <LoadingCustom /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('org.structure_view.worker_type_name')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                    setDataEdit(null);
                  }}
                >
                &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={workerTypeList}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
